import { makeStyles } from '@material-ui/core';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import InputBase from '~components/input/input';
import { BasicCalendar } from '~svg-components';

const useStyles = makeStyles((theme) => ({
  root: {
    '&$focused:not($error)': { '& $iconCalendar': { fill: theme.colors.brandAction } },
    '&$disabled': {
      '& $iconCalendar': { fill: theme.colors.grey99 },
    },
  },
  focused: {},
  error: {},
  disabled: {},
  input: {
    '&$inputAdornedStart': {
      paddingLeft: 36,
    },

    '&$inputAdornedEnd': {
      paddingRight: 36,
    },
  },
  inputAdornedStart: {},
  inputAdornedEnd: {},

  iconCalendar: {
    position: 'absolute',
    // top: 12,
    fill: theme.colors.grey66,
    pointerEvents: 'none',
  },

  iconCalendarStart: {
    left: 12,
  },

  iconCalendarEnd: {
    right: 12,
  },
}));

const Input = React.forwardRef(({ iconPlacement, tippyInstance, ...otherProps }, ref) => {
  const classes = useStyles();
  return (
    <InputBase
      ref={ref}
      classes={{
        root: classes.root,
        focused: classes.focused,
        error: classes.error,
        input: classes.input,
        disabled: classes.disabled,
        inputAdornedStart: classes.inputAdornedStart,
        inputAdornedEnd: classes.inputAdornedEnd,
      }}
      fullWidth
      startAdornment={
        iconPlacement === 'start' && (
          <BasicCalendar className={classNames(classes.iconCalendar, classes.iconCalendarStart)} />
        )
      }
      endAdornment={
        iconPlacement === 'end' && (
          <BasicCalendar className={classNames(classes.iconCalendar, classes.iconCalendarEnd)} />
        )
      }
      {...otherProps}
    />
  );
});

Input.propTypes = {
  iconPlacement: PropTypes.oneOf(['start', 'end']),
  tippyInstance: PropTypes.object,
};

Input.defaultProps = {
  iconPlacement: 'end',
  tippyInstance: undefined,
};

export default Input;
